<header
  class="wishlist-detail-header"
  [class.manager-header]="view().mode === 'manager'"
>
  <div class="header-meta">
    @if (hasOccasion()) {
      <span class="header-occasion">{{ view().occasionLabel }}</span>
    }
    <wishlist-status-pill
      class="header-status"
      [class.header-status-success]="isStatusSuccess()"
      [class.header-status-neutral]="isStatusNeutral()"
      [class.header-status-danger]="isStatusDanger()"
      [class.header-status-info]="isStatusInfo()"
      [label]="view().statusLabel"
      [tone]="view().statusTone"
    />
  </div>

  <div class="header-hero">
    <h1 class="header-title">{{ view().title }}</h1>

    @if (hasDescription()) {
      <p class="header-description">
        {{ view().description }}
      </p>
    }
  </div>

  <dl class="header-facts" aria-label="Szczegóły wishlisty">
    <div class="header-fact">
      <dt>{{ view().beneficiaryContextLabel }}</dt>
      <dd>{{ view().beneficiaryLabel }}</dd>
    </div>
    @if (hasCreator()) {
      <div class="header-fact">
        <dt>Utworzona przez</dt>
        <dd>{{ view().creatorLabel }}</dd>
      </div>
    }
    @if (hasManager() && view().managerLabel !== view().creatorLabel) {
      <div class="header-fact">
        <dt>Zarządzana przez</dt>
        <dd>{{ view().managerLabel }}</dd>
      </div>
    }
    @if (showVisibility() && view().mode !== 'manager') {
      <div class="header-fact">
        <dt>Dostęp</dt>
        <dd>
          <wishlist-visibility-indicator
            [label]="view().visibilityLabel"
            iconLabel="D"
            tone="neutral"
          />
        </dd>
      </div>
    }
  </dl>

  @if (hasAccountHint()) {
    <p class="header-account">{{ view().accountHint }}</p>
  }

  @if (hasStats()) {
    <ui-stat-grid class="header-stats" aria-label="Statystyki wishlisty">
      @for (stat of view().stats; track stat.label) {
        <ui-stat [value]="stat.value" [label]="stat.label" [tone]="stat.tone" />
      }
    </ui-stat-grid>
  }

  @if (showProgress()) {
    <wishlist-progress-summary
      [label]="view().progressLabel"
      [value]="view().progressValue"
      [max]="view().progressMax"
    />
  }

  @if (hasReservationHint()) {
    <p class="header-reservation-hint">
      {{ view().reservationHint }}
    </p>
  }

  @if (hasPrivacyNotice()) {
    <p class="header-notice">{{ view().privacyNotice }}</p>
  }

  <p class="header-role">{{ view().roleHint }}</p>

  @if (hasActions()) {
    <div class="header-actions" aria-label="Akcje wishlisty">
      @for (action of view().actions; track action.kind) {
        <ui-button
          [variant]="
            action.tone === 'info' || action.kind === 'add-item'
              ? 'primary'
              : 'secondary'
          "
          size="sm"
          (pressed)="handleActionSelected(action)"
        >
          {{ action.label }}
        </ui-button>
      }
    </div>
  }
</header>
